import React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import PreviewIcon from "@mui/icons-material/Preview";
import EditIcon from "@mui/icons-material/Edit";
import { WizardStep } from "../common/types";
import BrandDetailsForm from "./brandDetailsForm";
import { brandDetailsFormSchema } from "./brandDetailsForm";
import BrandAssetsSelection from "./brandAssetsSelection";
import { brandAssetsSelectionSchema } from "./brandAssetsSelection";
import EditGivingSite from "./editGivingSite";
import { editGivingSiteSchema } from "./editGivingSite";

export const BRAND_SETUP_STEP_LABELS = {
  brand: "Set up Branding",
  assets: "Select Assets",
  customize: "Customize Website",
} as const;

export const buildBrandSetupWizardSteps = (
  isManualSetup: boolean,
  _usesExternalGivingPage: boolean
): WizardStep[] => {
  const steps: WizardStep[] = [
    {
      label: BRAND_SETUP_STEP_LABELS.brand,
      icon: React.createElement(SettingsIcon, { fontSize: "small" }),
      Component: BrandDetailsForm,
      schema: brandDetailsFormSchema,
    },
  ];

  if (!isManualSetup) {
    steps.push({
      label: BRAND_SETUP_STEP_LABELS.assets,
      icon: React.createElement(PreviewIcon, { fontSize: "small" }),
      Component: BrandAssetsSelection,
      schema: brandAssetsSelectionSchema,
    });
  }

  steps.push({
    label: BRAND_SETUP_STEP_LABELS.customize,
    icon: React.createElement(EditIcon, { fontSize: "small" }),
    Component: EditGivingSite,
    schema: editGivingSiteSchema,
  });

  return steps;
};
